function initRebuyFbtProgress() {
  const widget = document.querySelector("#rebuy-widget-295853");

  if (!widget || widget.dataset.progressReady === "true") return;

  const track = widget.querySelector(".splide__track");
  const list = widget.querySelector(".splide__list");
  const content = widget.querySelector(".rebuy-widget-content");

  if (!track || !list || !content) return;

  const progress = document.createElement("div");
  progress.className = "as-rebuy-fbt-progress";
  progress.innerHTML = "<span></span>";

  content.appendChild(progress);

  const fill = progress.querySelector("span");

  const update = () => {
    const max = list.scrollWidth - track.clientWidth;
    const current = Math.abs(
      parseFloat(list.style.transform.replace(/[^\d.-]/g, "")) || 0,
    );

    const percent = max > 0 ? Math.min(current / max, 1) : 0;

    fill.style.width = "45%";
    fill.style.transform = `translateX(${percent * 122}%)`;
  };
  update();

  const observer = new MutationObserver(update);
  observer.observe(list, {
    attributes: true,
    attributeFilter: ["style"],
  });

  widget.dataset.progressReady = "true";
}

document.addEventListener("DOMContentLoaded", () => {
  initRebuyFbtProgress();

  setTimeout(initRebuyFbtProgress, 500);
  setTimeout(initRebuyFbtProgress, 1000);
  setTimeout(initRebuyFbtProgress, 2000);
  setTimeout(initRebuyFbtProgress, 4000);
});

document.addEventListener("rebuy:cart.show", initRebuyFbtProgress);
document.addEventListener("rebuy:cart.change", initRebuyFbtProgress);

setInterval(initRebuyFbtProgress, 1000);
